import GeneDomainInfo from './GeneDomainInfo';

export default GeneDomainInfo;